import React from 'react'
import { useTranslation } from 'react-i18next'
import { useInsightContentData } from 'hooks/useInsightModalState'
import CountType, { CountTypeStrings } from 'enums/CountType'
import { InsightContentSettingType } from 'components/insightContent/types'
import SparklineOverview from 'components/insightContent/visualization/Overview/SparklineOverview'
import { getPercentOfTotal, getMeasureTypeByCountType } from 'components/insightContent/utils/utils'
import { MetricTimeUnitStrings } from 'enums/MetricTimeUnit'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import { useTotalMeasureCount } from 'components/insightContent/hooks'

import RunSearchEffect from './RunSearchEffect'

const MeasureWithSentiment = ({
  detailSetting,
  countType,
  timeUnits,
  forceNotScale
}: {
  detailSetting: InsightContentSettingType
  countType: CountTypeStrings
  timeUnits?: MetricTimeUnitStrings[]
  forceNotScale?: boolean
}) => {
  const { t } = useTranslation()
  const insightContent = useInsightContentData(InsightContentType.MEASURE_WITH_SENTIMENT)
  const total = useTotalMeasureCount()
  const percent = getPercentOfTotal(
    insightContent?.data?.[0]?.results?.[0]?.data?.metrics?.[0]?.dataset?.[0]?.set?.[0],
    total
  )

  const displayCountType = () => {
    switch (countType) {
      case CountType.POSTS:
        return t('post_other')
      case CountType.AUTHORS:
        return t('author_other')
      case CountType.MENTIONS:
        return t('mention_other')
      default:
        return t('post_other')
    }
  }

  return (
    <UnexpectedErrorBoundary>
      <RunSearchEffect
        detailSetting={detailSetting}
        countType={countType}
        timeUnits={timeUnits}
        forceNotScale={forceNotScale}>
        <SparklineOverview
          displayTitleTooltip
          titleTooltipContent={t('insightModalMeasureWithSentimentTooltip')}
          title={t('withSentiment', { countType: displayCountType() })}
          count={
            insightContent?.data?.[0]?.results?.[0]?.data?.metrics?.[0]?.dataset?.[0]?.set?.[0]
          }
          percent={percent}
          sparklineData={
            insightContent?.data?.[0]?.results?.[0]?.data?.metrics?.[1]?.dataset?.[0]?.set
          }
          measureType={getMeasureTypeByCountType(countType)}
          status={insightContent?.status}
        />
      </RunSearchEffect>
    </UnexpectedErrorBoundary>
  )
}

export default MeasureWithSentiment
